import React, { FC } from 'react';
import { IOrder, ShippingCondition } from '../../graphql/types';

export const toShippingConditionDescription = (
  shippingCondition: ShippingCondition
): string => {
  switch (shippingCondition) {
    case '10':
      return 'Road pickup';
    case '11':
      return 'Road delivery';
    case '20':
      return 'Rail pickup';
    case '21':
      return 'Rail delivery';
    case '30':
      return 'Vessel pickup';
    case '31':
      return 'Vessel delivery';
    case '40':
      return 'Barge pickup';
    case '41':
      return 'Barge delivery';
    case '51':
      return 'Aviation delivery';
    case '52':
      return 'Into plane delivery';
    case '70':
      return 'Pipeline pickup';
    case '71':
      return 'Pipeline delivery';
    case '80':
      return 'In-Tank';
    case '91':
      return 'APO/STO multi mode';
    default:
      return '-';
  }
};

export const ShippingConditionData: FC<{ order: IOrder }> = ({ order }) => {
  if (
    !order.items ||
    !order.items.length ||
    !order.items[0].deliveries.length
  ) {
    return <span>-</span>;
  }
  return (
    <div>
      {toShippingConditionDescription(
        order.items[0].deliveries[0].shippingCondition
      )}
    </div>
  );
};
